import { GapNumber, GapMapped } from "./types"

const classes = {
  base: {
    0.25: "gap-0.25",
    0.5: "gap-0.5",
    1: "gap-1",
    2: "gap-2",
    3: "gap-3",
    4: "gap-4",
    5: "gap-5",
    6: "gap-6",
    7: "gap-7",
    8: "gap-8",
  },
  xs: {
    0.25: "xs:gap-0.25",
    0.5: "xs:gap-0.5",
    1: "xs:gap-1",
    2: "xs:gap-2",
    3: "xs:gap-3",
    4: "xs:gap-4",
    5: "xs:gap-5",
    6: "xs:gap-6",
    7: "xs:gap-7",
    8: "xs:gap-8",
  },
  sm: {
    0.25: "sm:gap-0.25",
    0.5: "sm:gap-0.5",
    1: "sm:gap-1",
    2: "sm:gap-2",
    3: "sm:gap-3",
    4: "sm:gap-4",
    5: "sm:gap-5",
    6: "sm:gap-6",
    7: "sm:gap-7",
    8: "sm:gap-8",
  },
  md: {
    0.25: "md:gap-0.25",
    0.5: "md:gap-0.5",
    1: "md:gap-1",
    2: "md:gap-2",
    3: "md:gap-3",
    4: "md:gap-4",
    5: "md:gap-5",
    6: "md:gap-6",
    7: "md:gap-7",
    8: "md:gap-8",
  },
  lg: {
    0.25: "lg:gap-0.25",
    0.5: "lg:gap-0.5",
    1: "lg:gap-1",
    2: "lg:gap-2",
    3: "lg:gap-3",
    4: "lg:gap-4",
    5: "lg:gap-5",
    6: "lg:gap-6",
    7: "lg:gap-7",
    8: "lg:gap-8",
  },
  xl: {
    0.25: "xl:gap-0.25",
    0.5: "xl:gap-0.5",
    1: "xl:gap-1",
    2: "xl:gap-2",
    3: "xl:gap-3",
    4: "xl:gap-4",
    5: "xl:gap-5",
    6: "xl:gap-6",
    7: "xl:gap-7",
    8: "xl:gap-8",
  },
}

export default function getGapClasses(gap: GapNumber | [GapNumber, GapMapped]) {
  const hasGapBreakpoints = Array.isArray(gap)
  const baseGapValue = hasGapBreakpoints ? gap[0] : gap
  const gapBpValues = hasGapBreakpoints ? gap[1] : undefined

  return [
    baseGapValue && classes.base[baseGapValue],
    gapBpValues?.xs && classes.xs[gapBpValues.xs],
    gapBpValues?.sm && classes.sm[gapBpValues.sm],
    gapBpValues?.md && classes.md[gapBpValues.md],
    gapBpValues?.lg && classes.lg[gapBpValues.lg],
    gapBpValues?.xl && classes.xl[gapBpValues.xl],
  ]
}
